var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.468,
    height: 15.276,
    viewBox: "0 0 15.468 15.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-696 -224.304)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(696 222)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.304)",
    fill: "none",
    stroke: "#818181",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.508,
    cy: 5.508,
    rx: 5.508,
    ry: 5.508,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.508,
    cy: 5.508,
    rx: 4.508,
    ry: 4.508,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    x2: 5.011,
    y2: 5.003,
    transform: "translate(9.042 11.162)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.65145d929a689a6feebdffdb03a0df5d.svg";
export { ForwardRef as ReactComponent };